import React from "react";
import Swal from "sweetalert2";
import { Avatar } from "@mui/material";
import { CameraAlt } from "@mui/icons-material";
import useFeedbackDialog from "../../utils/useFeedbackDialogue";

const SwalMediaImageUpload = ({ props, onUpload }) => {
  const { component = "img", isWithBlur = true } = props;
  const { showSuccess } = useFeedbackDialog();

  // 创建文件输入元素的引用
  const fileInputRef = React.createRef();

  // 处理文件上传
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // 创建文件读取器，用于预览图片
      const reader = new FileReader();
      reader.onload = (event) => {
        // 更新 SweetAlert 中的图片
        Swal.update({
          imageUrl: event.target.result,
          text: "Click Confirm to upload this image",
          confirmButtonText: "Confirm Upload",
        });

        // 存储当前上传的文件，供确认时使用
        Swal.currentFile = file;
      };
      reader.readAsDataURL(file);
    }
  };

  // 创建隐藏的文件输入元素
  const fileInput = (
    <input
      type='file'
      ref={fileInputRef}
      accept='image/*'
      onChange={handleFileChange}
      style={{ display: "none" }}
    />
  );

  const handleImageClick = () => {
    // 初始化当前文件为空
    Swal.currentFile = null;

    // 创建自定义的编辑按钮元素
    const editButton = document.createElement("button");
    editButton.innerHTML = '<CameraAlt fontSize="small" style="margin-right: 5px;" /> Upload';
    editButton.className = "swal2-styled swal2-cancel";
    editButton.onclick = () => {
      // 模拟点击文件输入元素，触发文件选择器
      fileInputRef.current.click();
      // 阻止默认的取消行为，保持弹窗打开
      return false;
    };

    // 显示 SweetAlert 弹窗
    Swal.fire({
      title: props.title,
      imageUrl: props.src,
      imageWidth: 800,
      imageHeight: "auto",
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      cancelButtonText: "Upload",
      showCloseButton: true,
      padding: "20px",
      customClass: {
        cancelButton: "hidden", // 隐藏默认的取消按钮
      },
      didOpen: (popup) => {
        // 将自定义编辑按钮添加到弹窗中
        const cancelButtonContainer = popup.querySelector(".swal2-cancel");
        if (cancelButtonContainer) {
          cancelButtonContainer.parentNode.replaceChild(editButton, cancelButtonContainer);
        }
      },
      preConfirm: () => {
        // 如果有选择的文件，执行上传
        if (Swal.currentFile) {
          if (typeof onUpload === "function") {
            return onUpload(Swal.currentFile);
          }
          return true;
        }
        return true;
      },
    }).then((result) => {
      if (result.isConfirmed && Swal.currentFile) {
        showSuccess("Upload Successful!", "Your image has been uploaded successfully.");
      }
    });
  };

  const commonProps = {
    ...props,
    alt: "click to enter swal dialogue",
    onClick: () => handleImageClick(),
  };
  delete commonProps.isWithBlur;

  if (component === "Avatar") {
    return (
      <>
        <Avatar {...commonProps} />
        {fileInput}
      </>
    );
  } else if (component === "img") {
    return (
      <>
        <div
          style={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: props.width,
            height: props.height,
            overflow: "hidden",
          }}
        >
          {isWithBlur ? (
            <img
              src={props.src}
              alt='blurred background'
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                filter: "blur(10px)",
                transform: "scale(1.1)",
              }}
            />
          ) : (
            <></>
          )}
          {/* 原始图片 */}
          <img
            {...commonProps}
            style={{
              position: "relative",
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
            }}
          />
        </div>
        {fileInput}
      </>
    );
  }
  return null;
};

export default SwalMediaImageUpload;
